import React, { useState } from 'react';
import {
  User, Building2, Mail, Phone, MapPin,
  Save, Edit3, X, AlertCircle, Briefcase,
  Shield, FileText, Hash, Calendar
} from 'lucide-react';
import { clientConnecte } from '../data/mockData';

const Profil = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    nom: clientConnecte.nom,
    prenom: clientConnecte.prenom,
    fonction: clientConnecte.fonction,
    email: clientConnecte.email,
    telephone: clientConnecte.telephone,
    portable: clientConnecte.portable,
    adresse: clientConnecte.adresse,
    codePostal: clientConnecte.codePostal,
    ville: clientConnecte.ville,
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      nom: clientConnecte.nom,
      prenom: clientConnecte.prenom,
      fonction: clientConnecte.fonction,
      email: clientConnecte.email,
      telephone: clientConnecte.telephone,
      portable: clientConnecte.portable,
      adresse: clientConnecte.adresse,
      codePostal: clientConnecte.codePostal,
      ville: clientConnecte.ville,
    });
    setIsEditing(false);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Mon établissement</h1>
          <p className="page-subtitle">Gérez les informations de l'établissement de santé et consultez vos conditions contractuelles</p>
        </div>
      </div>

      <div className="profil-grid">
        {/* Carte identité */}
        <div className="profil-identity-card">
          <div className="profil-avatar">
            <span>{clientConnecte.prenom[0]}{clientConnecte.nom[0]}</span>
          </div>
          <h2>{clientConnecte.prenom} {clientConnecte.nom}</h2>
          <p className="profil-fonction">{clientConnecte.fonction}</p>
          <p className="profil-company">{clientConnecte.raisonSociale}</p>
          <span className="profil-type-tag">{clientConnecte.type}</span>
          <div className="profil-meta">
            <span><Hash size={14} /> {clientConnecte.id}</span>
            <span><Calendar size={14} /> Client depuis {new Date(clientConnecte.dateCreation).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}</span>
          </div>
          <div className="profil-commercial">
            <User size={16} />
            <div>
              <span className="profil-commercial-label">Votre référent RESPIDOM</span>
              <span className="profil-commercial-name">{clientConnecte.commercial}</span>
              <a href={`mailto:${clientConnecte.commercialEmail}`} className="profil-commercial-link">
                <Mail size={12} /> {clientConnecte.commercialEmail}
              </a>
              <a href={`tel:${clientConnecte.commercialTelephone}`} className="profil-commercial-link">
                <Phone size={12} /> {clientConnecte.commercialTelephone}
              </a>
            </div>
          </div>
        </div>

        <div className="profil-main">
          {/* Coordonnées contact */}
          <div className="profil-card">
            <div className="profil-card-header">
              <h2><User size={20} /> Contact référent</h2>
              {!isEditing ? (
                <button className="btn-secondary" onClick={() => setIsEditing(true)}>
                  <Edit3 size={16} /> Modifier
                </button>
              ) : (
                <div className="profil-edit-actions">
                  <button className="btn-secondary" onClick={handleCancel}>
                    <X size={16} /> Annuler
                  </button>
                  <button className="btn-primary" onClick={handleSave}>
                    <Save size={16} /> Enregistrer
                  </button>
                </div>
              )}
            </div>

            <div className="profil-form-grid">
              <div className="profil-field">
                <label><User size={14} /> Nom</label>
                {isEditing ? (
                  <input type="text" value={formData.nom} onChange={(e) => handleChange('nom', e.target.value)} />
                ) : (
                  <p>{formData.nom}</p>
                )}
              </div>
              <div className="profil-field">
                <label><User size={14} /> Prénom</label>
                {isEditing ? (
                  <input type="text" value={formData.prenom} onChange={(e) => handleChange('prenom', e.target.value)} />
                ) : (
                  <p>{formData.prenom}</p>
                )}
              </div>
              <div className="profil-field profil-field-full">
                <label><Briefcase size={14} /> Fonction</label>
                {isEditing ? (
                  <input type="text" value={formData.fonction} onChange={(e) => handleChange('fonction', e.target.value)} />
                ) : (
                  <p>{formData.fonction}</p>
                )}
              </div>
              <div className="profil-field">
                <label><Mail size={14} /> Email</label>
                {isEditing ? (
                  <input type="email" value={formData.email} onChange={(e) => handleChange('email', e.target.value)} />
                ) : (
                  <p>{formData.email}</p>
                )}
              </div>
              <div className="profil-field">
                <label><Phone size={14} /> Téléphone</label>
                {isEditing ? (
                  <input type="tel" value={formData.telephone} onChange={(e) => handleChange('telephone', e.target.value)} />
                ) : (
                  <p>{formData.telephone}</p>
                )}
              </div>
              <div className="profil-field">
                <label><Phone size={14} /> Portable</label>
                {isEditing ? (
                  <input type="tel" value={formData.portable} onChange={(e) => handleChange('portable', e.target.value)} />
                ) : (
                  <p>{formData.portable}</p>
                )}
              </div>
            </div>

            {/* Infos établissement (lecture seule) */}
            <div className="profil-readonly-section">
              <h3><Shield size={16} /> Informations établissement (non modifiables)</h3>
              <div className="profil-form-grid">
                <div className="profil-field profil-field-full">
                  <label><Building2 size={14} /> Raison sociale</label>
                  <p>{clientConnecte.raisonSociale}</p>
                </div>
                <div className="profil-field profil-field-full">
                  <label><MapPin size={14} /> Adresse</label>
                  <p>{clientConnecte.adresse}, {clientConnecte.codePostal} {clientConnecte.ville}</p>
                </div>
                <div className="profil-field">
                  <label><Hash size={14} /> N° FINESS</label>
                  <p className="mono-text">{clientConnecte.numeroFiness}</p>
                </div>
                <div className="profil-field">
                  <label><Hash size={14} /> SIRET</label>
                  <p className="mono-text">{clientConnecte.siret}</p>
                </div>
                <div className="profil-field">
                  <label><FileText size={14} /> TVA intracommunautaire</label>
                  <p className="mono-text">{clientConnecte.tvaIntra}</p>
                </div>
              </div>
              <div className="profil-readonly-info">
                <AlertCircle size={14} />
                <p>Pour modifier les informations administratives de l'établissement, contactez votre référent RESPIDOM.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil;
